import React from 'react';
import SEO from '../components/SEO';

import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import PhilosophySection from '../components/PhilosophySection';
import DivisionsOverview from '../components/DivisionsOverview';
import FeaturedEvent from '../components/FeaturedEvent';
import ProgramsSection from '../components/ProgramsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">

      <SEO
        title="Bond Boxing Gym Gaborone | Boxing & Fitness Training"
        description="Discover Bond Boxing in Gaborone, Botswana. Explore boxing training, fitness programs, youth development and exciting boxing events. Find your place in the ring."
        path="/"
      />

      <Navigation />
      <HeroSection />
      <PhilosophySection />
      <DivisionsOverview />
      <FeaturedEvent />
      <ProgramsSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />

    </div>
  );
};

export default HomePage;